// src/pages/Profile/data/profileData.js

import { FaShieldAlt, FaUser, FaUserCircle } from "react-icons/fa";

export const DEFAULT_AVATAR = "/img/user_avatar.jpg";

export const ROLE_META = {
  1: {
    label: "Administrateur",
    badge:
      "border-red-200 bg-red-50 text-red-700 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-300",
    icon: FaShieldAlt,
  },
  2: {
    label: "Utilisateur",
    badge:
      "border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-500/20 dark:bg-blue-500/10 dark:text-blue-300",
    icon: FaUser,
  },
  3: {
    label: "Enseignant",
    badge:
      "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",
    icon: FaUserCircle,
  },
};

export const DEFAULT_ROLE_META = {
  label: "Rôle inconnu",
  badge:
    "border-slate-200 bg-slate-50 text-slate-700 dark:border-white/10 dark:bg-white/5 dark:text-slate-200",
  icon: FaUser,
};

export const INITIAL_USER_STATE = {
  id: "",
  nom: "",
  prenom: "",
  email: "",
  photoURL: "",
  role_id: 2,
  email_notifications_enabled: false,
  push_notifications_enabled: false,
};